var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-view',{attrs:{"LoginByUsername":_vm.LoginByUsername,"GetLoginVerCode":_vm.GetLoginVerCode,"LoginByMobile":_vm.LoginByMobile,"GetWxWebSiteQrInfo":_vm.GetWxWebSiteQrInfo}})}
var staticRenderFns = []

export { render, staticRenderFns }